<template>
    <div class="row">
        <loader-circle v-if="loader"></loader-circle>
        <div class="col-md-3">
            <div class="info-box mb-3">
                <span class="info-box-icon bg-danger elevation-1"
                    ><i class="fas fa-vials"></i
                ></span>

                <div class="info-box-content">
                    <span class="info-box-text">Tested</span>
                    <span class="info-box-number">{{ totalTested }}</span>
                </div>
                <!-- /.info-box-content -->
            </div>
        </div>
        <div class="col-md-5 offset-md-4">
            <div class="">
                <label>
                    Date From
                    <input type="date" name="dateFrom" v-model="dateFrom" class="form-control"/>
                </label>
                
                <label>
                    Date To 
                    <input type="date" name="dateTo" v-model="dateTo" class="form-control"/>
                </label>
                <button class="btn btn-sm btn-primary" v-on:click="testedCounters">
                    Submit
                </button>
            </div>
        </div>
        <div class="col-md-12">
            <div class="card">
                <div id="chartdivTested"></div>
            </div>
        </div>
    </div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import loaderCircle from './../../inc/loader/LoaderCircle';
//default theme for AMcharts
am4core.useTheme(am4themes_animated);
export default {
    components: { loaderCircle },
    name: 'city-wise-vcct-tested',
    data() {
        return {
            loader: true,
            registration: null,
            year: 2021,
            totalTested: null,
            // years: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021]
            dateFrom: "",
            dateTo: ""
        };
    },
    methods: {
        testedCounters() {
            this.loader = true;
            axios
                .post("cityWiseVcctTested", {
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo
                })
                .then(response => {
                    this.totalTested = response.data[1];
                    this.populateCityWise(response.data[0]);
                })
                .catch(error => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        populateCityWise(data) {
            am4core.ready(function() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                var chart = am4core.create(
                    "chartdivTested",
                    am4charts.XYChart
                );

                chart.data = data;
                chart.zoomOutButton.align = "left";
                chart.zoomOutButton.valign = "bottom";
                chart.zoomOutButton.parent = chart.tooltipContainer;
                chart.padding(40, 40, 40, 40);

                // Title
                let title = chart.titles.create();
                title.text = "Tested Clients City Wise";
                title.fontSize = 18;
                title.marginBottom = 30;

                var categoryAxis = chart.xAxes.push(
                    new am4charts.CategoryAxis()
                );
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "CityName";
                categoryAxis.renderer.minGridDistance = 60;
                categoryAxis.renderer.inversed = true;
                categoryAxis.renderer.grid.template.disabled = true;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.extraMax = 0.1;
                //valueAxis.rangeChangeEasing = am4core.ease.linear;
                //valueAxis.rangeChangeDuration = 1500;

                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = "CityName";
                series.dataFields.valueY = "total";
                series.tooltipText = "{valueY.value}";
                series.columns.template.strokeOpacity = 0;
                series.columns.template.column.cornerRadiusTopRight = 10;
                series.columns.template.column.cornerRadiusTopLeft = 10;
                //series.interpolationDuration = 1500;
                //series.interpolationEasing = am4core.ease.linear;
                var labelBullet = series.bullets.push(
                    new am4charts.LabelBullet()
                );
                labelBullet.label.verticalCenter = "bottom";
                labelBullet.label.dy = -20;
                labelBullet.label.dx = 10;
                labelBullet.label.truncate = false;
                labelBullet.label.rotation = 270;
                labelBullet.label.text =
                    "{values.valueY.workingValue.formatNumber('#.')}";

                chart.zoomOutButton.disabled = true;

                // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                series.columns.template.adapter.add("fill", function(
                    fill,
                    target
                ) {
                    return chart.colors.getIndex(target.dataItem.index);
                });

                categoryAxis.renderer.labels.template.rotation = 270;
                categoryAxis.renderer.labels.template.dx = -20;
                categoryAxis.renderer.minGridDistance = 1;

                // let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
                // categoryLabel.label.text = "{CityName}";
                // categoryLabel.label.fontSize = 20;
                // categoryLabel.label.horizontalCenter = "right";
                // categoryLabel.label.dx = 0;
                // categoryLabel.label.fill = am4core.color("#000");
                // categoryLabel.label.dy = -50;
                // categoryLabel.label.rotation = 270;
                // categoryLabel.label.truncate = false;
                // categoryAxis.sortBySeries = series;
            }); // end am4core.ready()
        }
    },
    mounted() {
        this.dateFrom = "2020-07-01";
        this.dateTo = new Date().toISOString().split("T")[0];
        this.testedCounters();
    }
};
</script>

<style lang="scss" scoped>
#chartdivTested {
    width: 100%;
    height: 500px;
}
</style>

